import React from "react";
import { Link } from "react-router-dom";
import { Socials } from "../home";

const PrivacyPolicy = () => {
  return (
    <div className="min-h-screen relative overflow-hidden mt-20">
      <div className="container mx-auto px-4 py-16 relative z-10">
        <h1 className="text-4xl md:text-5xl font-bold text-white mb-8 text-center animate-fade-in">
          Privacy Policy
        </h1>

        <div
          className="max-w-4xl mx-auto text-white/80 space-y-6 text-lg animate-fade-in"
          style={{ animationDelay: "0.3s" }}
        >
          <p className="text-center text-market-teal">
            Effective Date: April 1, 2025
          </p>

          <h2 className="text-2xl font-semibold text-white pt-8 mt-8">
            The Agreement
          </h2>
          <p>
            The use of this website and services provided by
            marketpulse.exchange (hereinafter referred to as "Owner") are
            subject to the following Terms & Conditions (hereinafter the
            "Privacy Policy"), all parts of which are incorporated by reference
            here together with the Terms of Service. The Privacy Policy governs
            your use of https://marketpulse.exchange/ (the "Website"), including
            all its pages and services offered.
          </p>
          <p>
            By accessing the Website, either directly or through a hyperlink,
            and/or purchasing a service from us, you engage in our "Service" and
            agree to be bound by this Privacy Policy including all referenced
            terms and policies. This applies to all users including vendors,
            buyers, customers, browsers, and/or contributors of content. You
            acknowledge and agree that marketpulse.exchange may use your
            personal data as outlined herein.
          </p>

          <h2 className="text-2xl font-semibold text-white pt-8 mt-8">
            1. Definitions
          </h2>
          <ul className="list-disc list-inside space-y-3">
            <li>
              Owner, Us, We: Refers to marketpulse.exchange and its team, as the
              creators, operators, and publishers of the Website.
            </li>
            <li>
              You, the User: Any natural or legal person accessing or using the
              Website.
            </li>
            <li>
              Parties: Collectively refers to both the Owner and the User.
            </li>
          </ul>

          <h2 className="text-2xl font-semibold text-white pt-8 mt-8">
            2. Assent & Acceptance
          </h2>
          <p>
            By using the Website, you confirm that you have read this Privacy
            Policy and agree to its terms. If you do not agree, please stop
            using the Website immediately.
          </p>

          <h2 className="text-2xl font-semibold text-white pt-8 mt-8">
            3. Age Restriction
          </h2>
          <p>
            Users must be at least 18 years of age to use this Website. By
            accessing the Website, you represent that you are eligible.
          </p>

          <h2 className="text-2xl font-semibold text-white pt-8 mt-8">
            4. About the Site
          </h2>
          <p>
            marketpulse.exchange offers digital services including market
            scanners, trade alerts, and educational tools. We reserve the right
            to deny service at our discretion.
          </p>

          <h2 className="text-2xl font-semibold text-white pt-8 mt-8">
            5. License to Use Website
          </h2>
          <p>
            You are granted a limited, revocable, non-exclusive license to
            access and use the Website for personal use, subject to compliance
            with this Privacy Policy and other posted terms.
          </p>

          <h2 className="text-2xl font-semibold text-white pt-8 mt-8">
            6. Intellectual Property
          </h2>
          <p>
            All content, tools, reports, and logos on the Website are
            intellectual property of the Owner and may not be copied or
            redistributed without written consent.
          </p>

          <h2 className="text-2xl font-semibold text-white pt-8 mt-8">
            7. User Obligations
          </h2>
          <p>
            You are responsible for providing accurate information and
            maintaining account confidentiality. Any misuse may lead to account
            termination.
          </p>

          <h2 className="text-2xl font-semibold text-white pt-8 mt-8">
            8. Payment & Fees
          </h2>
          <p>
            All services offered are subject to payment. All purchases are final
            and non-refundable.
          </p>

          <h2 className="text-2xl font-semibold text-white pt-8 mt-8">
            9. Acceptable Use
          </h2>
          <p>
            You agree to use the Website only for lawful purposes and to not
            violate the rights of others or the integrity of the platform.
          </p>

          <h2 className="text-2xl font-semibold text-white pt-8 mt-8">
            10. Communication
          </h2>
          <p>
            By using the Website, you consent to receive communications
            including promotional messages via email or posted notices.
          </p>

          <h2 className="text-2xl font-semibold text-white pt-8 mt-8">
            11. Affiliate Marketing & Advertising
          </h2>
          <p>
            marketpulse.exchange may participate in affiliate marketing programs
            or host sponsored content.
          </p>

          <h2 className="text-2xl font-semibold text-white pt-8 mt-8">
            12. Privacy Information
          </h2>
          <p>Information We May Collect:</p>
          <ul className="list-disc list-inside space-y-3">
            <li>Contact information (name, email, etc.)</li>
            <li>Account and billing details</li>
            <li>Activity data and site usage</li>
            <li>Technical information (IP address, browser type, cookies)</li>
          </ul>

          <p>How We Use Your Information:</p>
          <ul className="list-disc list-inside space-y-3">
            <li>To provide and maintain services</li>
            <li>To improve site experience and support</li>
            <li>To communicate with users and send updates</li>
            <li>For legal, regulatory, or compliance purposes</li>
          </ul>

          <p>Data Retention & Security:</p>
          <p>
            Your data may be stored securely for up to 90 days after account
            closure unless otherwise required by law. We employ reasonable
            security measures but cannot guarantee complete protection.
          </p>

          <p>Third-Party Sharing:</p>
          <p>
            We do not sell your personal data. We may share your data with
            trusted service providers under confidentiality agreements solely to
            deliver our services.
          </p>

          <h2 className="text-2xl font-semibold text-white pt-8 mt-8">
            13. Assumption of Risk
          </h2>
          <p>
            Your use of the Website is at your own risk. Content shared is for
            educational purposes and should not be construed as financial
            advice.
          </p>

          <h2 className="text-2xl font-semibold text-white pt-8 mt-8">
            14. Sale of Goods/Services
          </h2>
          <p>
            While we strive to provide accurate information, market conditions
            may affect outcomes. Users must evaluate services based on their own
            needs.
          </p>

          <h2 className="text-2xl font-semibold text-white pt-8 mt-8">
            15. Reverse Engineering & Security
          </h2>
          <p>
            You may not tamper with, reverse engineer, or compromise the
            Website's security systems.
          </p>

          <h2 className="text-2xl font-semibold text-white pt-8 mt-8">
            16. Data Loss
          </h2>
          <p>
            We are not responsible for any data loss. Please use the platform
            responsibly.
          </p>

          <h2 className="text-2xl font-semibold text-white pt-8 mt-8">
            17. Indemnification
          </h2>
          <p>
            You agree to indemnify and hold harmless marketpulse.exchange
            against any legal issues arising from your use of the Website.
          </p>

          <h2 className="text-2xl font-semibold text-white pt-8 mt-8">
            18. Spam Policy
          </h2>
          <p>
            We prohibit spam, unsolicited messages, or harvesting of user
            information.
          </p>

          <h2 className="text-2xl font-semibold text-white pt-8 mt-8">
            19. Third-Party Links
          </h2>
          <p>
            We are not responsible for the privacy practices or content of
            third-party websites.
          </p>

          <h2 className="text-2xl font-semibold text-white pt-8 mt-8">
            20. Modification & Variation
          </h2>
          <p>
            We may update this Privacy Policy at any time. Continued use after
            changes constitutes agreement.
          </p>

          <h2 className="text-2xl font-semibold text-white pt-8 mt-8">
            21. Jurisdiction
          </h2>
          <p>
            This Privacy Policy is governed by Indian law. All disputes shall be
            resolved under the jurisdiction of Bhopal, Madhya Pradesh, India.
          </p>

          <h2 className="text-2xl font-semibold text-white pt-8 mt-8">
            22. Contact Us
          </h2>
          <p>
            If you have any questions or concerns: Email:
            <a
              className="text-market-teal/40 hover:text-market-teal"
              href="mailto://hello@projectoptions.in"
            >
              hello@projectoptions.in
            </a>
          </p>

          <div className="intellectia-card p-8 mt-12 text-center">
            <h3 className="text-xl font-semibold mb-4">Contact Us</h3>
            <p className="mb-6">
              If you have any questions about our Privacy Policy, please contact
              our support team.
            </p>
            < Socials />

          </div>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
